<template>
  <div>
    <data-form
      ref="searchForm"
      :content="searchContent"
      :data="searchFormData"
      :fixedLabelWidth="true"
      :labelCol="4"
      :colnum="7"
      :showButton="false"
      style="width:100%;"
    >
      <template slot="search">
        <a-button style="margin-left:10px;" type="primary" @click="handleSearch"
          >搜索</a-button
        >
      </template>
    </data-form>
    <a-tabs defaultActiveKey="" @change="tabChange">
      <a-tab-pane tab="全部订单" key=""></a-tab-pane>
      <a-tab-pane tab="预订" key="0"></a-tab-pane>
      <a-tab-pane tab="在住" key="1"></a-tab-pane>
      <a-tab-pane tab="取消" key="4"></a-tab-pane>
      <a-tab-pane tab="暂离" key="3"></a-tab-pane>
      <a-tab-pane tab="完成" key="2"></a-tab-pane>
    </a-tabs>
    <data-grid
      ref="dataTable"
      :columns="columns"
      api="GroupOrder_OrderList"
      v-model="data"
      :params="params"
      :pagination="true"
      :props="props"
      bordered
    >
      <template slot="orderNumber" slot-scope="text, record">
        <a @click="orderDetail(record)">{{ record.No }}</a>
      </template>
    </data-grid>
  </div>
</template>
<script>
import moment from "moment";
moment.locale("zh-cn");
import { DataGrid } from "@/components/dataGrid";
import { DataForm } from "@/components/dataForm";
import { GroupOrderDetailModal } from "./index.js";
const columns = [
  {
    title: "序号",
    width: "4%",
    align: "center",
    type: "indexcolumn"
  },
  {
    title: "订单号",
    width: 100,
    dataIndex: "No",
    align: "center",
    scopedSlots: { customRender: "orderNumber" }
  },
  {
    title: "订单日期",
    width: 140,
    dataIndex: "OrderTime"
  },
  {
    title: "门店名称",
    width: 120,
    dataIndex: "CompanyName"
  },
  {
    title: "状态",
    width: 80,
    dataIndex: "StatusName"
  },
  {
    title: "业务员",
    dataIndex: "SalesmanName",
    width: 80
  },
  {
    title: "渠道",
    dataIndex: "ChannelName",
    width: 100
  },
  {
    title: "住店日期",
    dataIndex: "CheckInDate",
    width: 120
  },
  {
    title: "离店日期",
    dataIndex: "CheckOutDate",
    width: 120
  },
  {
    title: "客人姓名",
    width: 120,
    dataIndex: "GuestNmae"
  },
  {
    title: "手机号码",
    width: 120,
    dataIndex: "Phone"
  },
  {
    title: "房数",
    width: 80,
    dataIndex: "RoomCount"
  },
  {
    title: "人数",
    width: 80,
    dataIndex: "PersonCount"
  },
  {
    title: "备注",
    dataIndex: "Remark",
    tooltip: true
  }
];
export default {
  components: {
    DataForm,
    DataGrid
  },
  data() {
    return {
      form: this.$form.createForm(this),
      Status: "",
      searchFormData: {},
      columns,
      props: {
        scroll: { x: 1600, y: window.document.body.clientHeight - 330 }
      },
      data: [],
      params: {},
      visible: {
        maskClosable: false,
        showModal: false
      },
      PageIndex: 0,
      PageSize: 10
    };
  },
  beforeCreate() {
    const _this = this;
    this.form = this.$form.createForm(this);
    this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
    this.searchContent = [
      {
        label: "预订日期",
        name: "DateRange",
        type: "date-range-picker",
        colnum: 2
      },
      {
        label: "门店",
        name: "CompanyId",
        placeholder: "请选择门店",
        type: "select",
        api: "GetGroupSelectItems",
        param: { Types: "company" },
        valueField: "Id",
        textField: "Text",
        dataField: "Data.company",
        width: "160px",
        onChange: value => {
          _this.handleChangeSearch(value);
        }
      },
      {
        label: "渠道",
        name: "Channel",
        placeholder: "请选择渠道",
        type: "select",
        width: "160px",
        api: "GetGroupSelectItems",
        param: { Types: "companychannel" },
        dataField: "Data.companychannel"
      },
      {
        label: "关键字",
        name: "KeyWord",
        colnum: 2,
        props: {
          placeholder: "请输入订单号/联系人/电话"
        }
      },
      {
        label: "",
        slot: "search"
      }
    ];
  },
  created() {},
  methods: {
    handleChangeSearch(value) {
      const form = this.$refs.searchForm;
      if (value == "") {
        form.setFieldData("Channel", []);
      } else {
        this.$post("GetGroupSelectItems", {
          Types: "companychannel",
          CompanyId: value
        }).then(res => {
          form.setFieldData("Channel", res.Data.companychannel);
          form.form.setFieldsValue({ Channel: "" });
        });
      }
    },
    orderDetail(record) {
      GroupOrderDetailModal({
        orderId: record.Id,
        submitApi: "GroupOrder_UpdateOrder",
        CompanyId: record.CompanyId,
        update: () => {
          // this.getData();
          this.$refs.dataTable.reload();
        }
      });
    },
    tabChange(key) {
      this.Status = key;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    getData() {
      const fields = this.$refs.searchForm.getData();
      this.PageIndex = this.$refs.dataTable.paginationOption.PageIndex;
      let BeginDate = "",
        EndDate = "";
      if (fields.DateRange) {
        if (fields.DateRange[0]) {
          BeginDate = moment(fields.DateRange[0]).format("YYYY-MM-DD");
        }
        if (fields.DateRange[1]) {
          EndDate = moment(fields.DateRange[1]).format("YYYY-MM-DD");
        }
      }
      this.params = {
        Status: this.Status,
        CompanyId: fields.CompanyId,
        BeginDate: BeginDate,
        EndDate: EndDate,
        ChannelId: fields.Channel,
        KeyWord: fields.KeyWord,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      };
    }
  }
};
</script>

<style lang="less" scoped>
.data-form-box /deep/ .fixed-label-width .ant-form-item .ant-form-item-label {
  width: 80px;
}
</style>
